import { z } from 'zod';
import { UUIDValidationSchema } from './uuid';
const GetContributorValidationSchema = z.object({
    workshopId: UUIDValidationSchema
});
const AddContributorValidationSchema = z.object({
    firstName: z.string(),
    lastName: z.string(),
    workshopId: UUIDValidationSchema
});
export { AddContributorValidationSchema, GetContributorValidationSchema };
//# sourceMappingURL=contributor.js.map